import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';

@Component({
  selector: 'logzy-request-initial',
  templateUrl: './request-initial.component.html',
  styleUrls: ['./request-initial.component.scss']
})
export class RequestInitialComponent implements OnInit {
  @Output() accept = new EventEmitter<any>();
  @Output() reject = new EventEmitter<any>();
  @Input() commercials;
  commercialData;

  @Input()
  isBookingConfirmed: boolean = false;

  @Input() requestType;
  // tableData = [
  //   {
  //     colhead: 'Quantity',
  //     coldata: this.quantity
  //   },
  //   {
  //     colhead: 'Pick-Up Charge',
  //     coldata: this.pickup_charge + ' ' + this.pickup_charge_currency
  //   },
  //   {
  //     colhead: 'Free Days',
  //     coldata: this.min_free_days + ' /' + this.max_free_days
  //   },
  //   {
  //     colhead: 'Per Diem (in USD)',
  //     coldata: this.min_per_diem + ' /' + this.max_per_diem
  //   },
  //   {
  //     colhead: 'DPP/cont.',
  //     coldata: this.dpp_charge + ' ' + this.dpp_charge_currency
  //   },
  //   {
  //     colhead: 'Storage Charge/cont.',
  //     coldata: this.storage_charge + ' ' + this.storage_charge_currency
  //   },
  //   {
  //     colhead: 'Insurance',
  //     coldata: this.insurance
  //   },
  //   {
  //     colhead: 'Drop-off Fee/cont.',
  //     coldata: this.dropoff_charge + ' ' + this.dpp_charge_currency
  //   },
  //   {
  //     colhead: 'Cancellation Fee/cont.',
  //     coldata: this.cancellation_charge + ' ' + this.cancellation_charge_currency
  //   },
  //   {
  //     colhead: 'New Build Price',
  //     coldata: this.new_build_charge + ' ' + this.new_build_charge_currency
  //     // coldata: '$50.00 USD'
  //   },
  //   {
  //     colhead: 'Depreciation Per Year',
  //     coldata: this.depreciation + ' %'
  //   },
  //   {
  //     colhead: 'Maximum Depreciation',
  //     coldata: this.drv_max_depreciation_percent + ' %'
  //   },
  //   {
  //     colhead: 'Remarks',
  //     coldata: this.remarks
  //   },

  // ]
  acceptRequest() {
    this.accept.emit();
  }
  rejectRequest() {
    this.reject.emit();
  }
  constructor(private requestService: RequestApiService) {

  }

  ngOnInit(): void {
    this.commercialData = this.commercials.latest_quote;
  }

}
